/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adjust_Focal_PointInputs */

const en_adjust_focal_point = /** @type {(inputs: Adjust_Focal_PointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjust Focal Point`)
};

const es_adjust_focal_point = /** @type {(inputs: Adjust_Focal_PointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar punto focal`)
};

const fr_adjust_focal_point = /** @type {(inputs: Adjust_Focal_PointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuster le point focal`)
};

const de_adjust_focal_point = /** @type {(inputs: Adjust_Focal_PointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokuspunkt anpassen`)
};

const ja_adjust_focal_point = /** @type {(inputs: Adjust_Focal_PointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォーカルポイントを調整`)
};

const zh_adjust_focal_point = /** @type {(inputs: Adjust_Focal_PointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`调整焦点`)
};

const ar_adjust_focal_point = /** @type {(inputs: Adjust_Focal_PointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ضبط نقطة التركيز`)
};

const id_adjust_focal_point = /** @type {(inputs: Adjust_Focal_PointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesuaikan Titik Fokus`)
};

const it_adjust_focal_point = /** @type {(inputs: Adjust_Focal_PointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regola punto focale`)
};

const ru_adjust_focal_point = /** @type {(inputs: Adjust_Focal_PointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настроить точку фокуса`)
};

const pt_adjust_focal_point = /** @type {(inputs: Adjust_Focal_PointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar ponto focal`)
};

const ko_adjust_focal_point = /** @type {(inputs: Adjust_Focal_PointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초점 조정`)
};

/**
* | output |
* | --- |
* | "Adjust Focal Point" |
*
* @param {Adjust_Focal_PointInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const adjust_focal_point = /** @type {((inputs?: Adjust_Focal_PointInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adjust_Focal_PointInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_adjust_focal_point(inputs)
	if (locale === "es") return es_adjust_focal_point(inputs)
	if (locale === "fr") return fr_adjust_focal_point(inputs)
	if (locale === "de") return de_adjust_focal_point(inputs)
	if (locale === "ja") return ja_adjust_focal_point(inputs)
	if (locale === "zh") return zh_adjust_focal_point(inputs)
	if (locale === "ar") return ar_adjust_focal_point(inputs)
	if (locale === "id") return id_adjust_focal_point(inputs)
	if (locale === "it") return it_adjust_focal_point(inputs)
	if (locale === "ru") return ru_adjust_focal_point(inputs)
	if (locale === "pt") return pt_adjust_focal_point(inputs)
	return ko_adjust_focal_point(inputs)
});